import { cn } from "@/shared/lib/utils";

/**
 * Shared column template for the contacts table so the header, the data
 * rows, and the loading skeleton can't drift apart.
 *
 * Tiers:
 *   base: checkbox | Name
 *   md:   + Email + Address
 *   lg:   + Phone (between Email and Address)
 *   xl:   + Tags (after Address)
 *
 * `minmax(0, Nfr)` (not bare `Nfr`, which is `minmax(auto, Nfr)`) lets each
 * column shrink below its content's intrinsic width so truncated cells clip
 * instead of pushing the row past the table's right edge.
 */
export const GRID_TEMPLATE = cn(
  "grid-cols-[auto_minmax(0,1fr)]",
  "md:grid-cols-[auto_minmax(0,2fr)_minmax(0,2fr)_minmax(0,2fr)]",
  "lg:grid-cols-[auto_minmax(0,2fr)_minmax(0,2fr)_minmax(0,1.5fr)_minmax(0,2fr)]",
  "xl:grid-cols-[auto_minmax(0,2fr)_minmax(0,2fr)_minmax(0,1.5fr)_minmax(0,2fr)_minmax(0,1.5fr)]",
);

/** Subgrid span for the clickable row link across the non-checkbox columns. */
export const ROW_LINK_SPAN = "col-span-1 md:col-span-3 lg:col-span-4 xl:col-span-5";
